import { ISelectOption } from '../../../components';
import { IAchAccountResponse } from '../../../../types/accounting/response/IEscrowExpectedAchPullDepositResponse';

export const getISelectOptionsFromIAchAccountResponse = (achAccounts: IAchAccountResponse[]): ISelectOption[] => {
  return achAccounts.map((achAccount) => {
    return {
      label:
        achAccount.name +
        ` - (ACCT: ${achAccount.accountNumber} RTN: ${achAccount.routingNumber}) - ${achAccount.accountType}`,
      value: { ...achAccount, accountNumberConfirmation: achAccount.accountNumber },
    };
  });
};
